import axios from "axios";

const state = {
  user: "null",
  posts: "null",
};

const getters = {
  isAuthenticated: (state) => !!state.user,
  StatePosts: (state) => state.posts,
  StateUser: (state) => state.user,
};

const actions = {
  async Register({dispatch}, form) {
    await axios.post('auth/register', form)
    let UserForm = new FormData()
    UserForm.append('email', form.email)
    UserForm.append('password', form.password)
    await dispatch('LogIn', UserForm)
  },

  async LogIn({commit}, user) {
    await axios.post("auth/login", user);
    await commit("setUser", user);
  },

  // async CreatePost({ dispatch }, post) {
  //   await axios.post("post", post);
  //   return await dispatch("GetPosts");
  // },

  // async GetPosts({ commit }) {
  //   let response = await axios.get("posts");
  //   commit("setPosts", response.data);
  // },

  async LogOut({ commit }) {
    let user = null;
    commit("logout", user);
  },
};

const mutations = {
  setUser(state, email) {
    state.user = email;
  },

  setPosts(state, posts) {
    state.posts = posts;
  },
  logout(state, user) {
    state.user = user;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};